import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { PlateItRightImageThumbnail } from '../../../features/PpsiContainer/constants';
import StepInstructionsField from '../../Form/Fields/StepInstructionsField';
import StepCardContent from './StepCardContent';
import SectionHeader from '../../Form/Fields/SectionHeader';
import UnitTextField from '../../Form/Fields/UnitTextField';
import TextField from '../../Form/Fields/TextField';
import Switch from '../../Form/Fields/Switch';
import { getConfigs } from '../../../features/app/selectors';
import FormContext from '../../Form/FormContext';
// import { getTimeUnitsTranslated } from '../../../features/app/timeUnitSelectors';
import { getLanguage } from '../../../features/app/selectors';
// import { getTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';

const PlatingTabContent = ({ globalData, data, mode }) => {
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  // const timeUnits = useSelector(getTimeUnitsTranslated).toJS();
  const getConfigData = useSelector(getConfigs).toJS();
  const showHoldingInfoOnDishLevel = getFieldValue(
    'showHoldingInfoOnDishLevel'
  );
  const language = useSelector(getLanguage);
  // const temperatureUnits = useSelector(getTemperatureUnits).toJS();

  const tempUnitForDropDown = [];
  getConfigData &&
    getConfigData.temperatureUnits.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.slug = item.info[language].slug;
      obj.text = item.info[language].text;
      obj.textShort = item.info[language].textShort;
      tempUnitForDropDown.push(obj);
    });

  const timeUnitForDropDown = [];
  getConfigData &&
    getConfigData.timeUnits.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.ratio = item.ratio;
      obj.slug = item.info[language].slug;
      obj.text = item.info[language].text;
      obj.textShort = item.info[language].textShort;
      timeUnitForDropDown.push(obj);
    });

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <SectionHeader translationId="ppsi.servingHeader" />
        <Grid item sm={12} md={6}>
          <Switch
            label="ppsi.showHoldingInfoOnDishLevel"
            dataField="showHoldingInfoOnDishLevel"
            helperText="ppsi.showHoldingInfoOnDishLevelHelperText"
            injectAction={checked => {
              if (!checked) {
                setFieldValue('servingHoldingTime', '');
                setFieldValue('servingHoldingTemp', '');
              }
            }}
          />
        </Grid>

        <Grid container spacing={2}>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppsi.dishHoldingTime"
              dataField="servingHoldingTime"
              helperText="ppsi.dishHoldingTimeHelperText"
              disabled={!showHoldingInfoOnDishLevel}
              units={timeUnitForDropDown}
            />
          </Grid>
          <Grid item sm={6} md={3}>
            <UnitTextField
              label="ppsi.dishHoldingTemp"
              dataField="servingHoldingTemp"
              helperText="ppsi.dishHoldingTempHelperText"
              disabled={!showHoldingInfoOnDishLevel}
              units={tempUnitForDropDown}
            />
          </Grid>
        </Grid>
      </Grid>
      <StepInstructionsField
        dataField="servingInstructions"
        StepContent={StepCardContent}
        header="ppsi.plateItRightHeader"
        thumbnailHeight={PlateItRightImageThumbnail.Height}
        thumbnailWidth={PlateItRightImageThumbnail.Width}
        globalData={globalData}
        data={data}
        mode={mode}
      />
    </Grid>
  );
};

export default PlatingTabContent;
